import { cn } from '@/shared/lib';
import { Button, Typography } from '@/shared/ui';

import { ICurrency } from '../types';
import { CurrencyIcon } from './currency-icon';

interface CurrencyItemProps {
  currency: ICurrency;
  className?: string;
}

export const CurrencyItem = ({ currency, className }: CurrencyItemProps) => {
  return (
    <Button
      variant="base-500"
      className={cn(
        'flex h-[72px] w-full items-center justify-start gap-x-4 px-4 py-2 !text-base-500 hover:!text-base-500 active:!text-base-500',
        className,
      )}
    >
      <CurrencyIcon ticker={currency.ticker} size="lg" />
      <Typography variant="16-r">{currency.name}</Typography>
    </Button>
  );
};
